/* eslint-disable jsx-a11y/no-static-element-interactions */
import { useQuery } from '@apollo/react-hooks';
import React from 'react';
import ReactDOM from 'react-dom';
import Loader from '../../../components/UI/Loader/Loader';
import { CHECKOUT_AGREEMENTS } from '../../../queries/cart';
import './TermsAndConditions.scss';

const TermsAndConditions = ({ setIsTermsOpen }) => {
  const { data, loading } = useQuery(CHECKOUT_AGREEMENTS);

  const element = (
    <div className="terms-and-conditions">
      <div onClick={() => setIsTermsOpen(false)} className="terms-and-conditions__background" />

      {loading && <Loader />}

      {data && (
        <div className="terms-and-conditions__box">
          <div className="terms-and-conditions__header">
            <h1 className="terms-and-conditions__title">{data.checkoutAgreements[0].name}</h1>
            <div className="terms-and-conditions__close" onClick={() => setIsTermsOpen(false)} />
          </div>

          <div
            className="terms-and-conditions__content"
            dangerouslySetInnerHTML={{
              __html: data.checkoutAgreements[0].content,
            }}
          />
        </div>
      )}
    </div>
  );

  return ReactDOM.createPortal(element, document.body);
};

export default TermsAndConditions;
